import { TabHeader } from "~/pages/manifold-nextgen/components/TabHeader";
import { PinnedArtifacts } from "./PinnedArtifacts";
import { useProjectContext } from "./useProjectContext";

/** The project's pinned artifacts, as their own page. Every member sees them; owners curate. */
export const ProjectArtifacts = () => {
  const { project, isOwner } = useProjectContext();

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-6 px-4 pt-4 pb-6 sm:px-6">
        <TabHeader
          title="Artifacts"
          description="Charts and tables pinned from sessions. Anyone in the project can refresh them."
        />
        <PinnedArtifacts projectId={project.id} canCurate={isOwner} />
      </div>
    </div>
  );
};
